import { Form } from 'react-bootstrap';
import { useFieldArray, useFormContext } from 'react-hook-form';
import FieldError from '../../../../shared/fields-errors/field-error';
import CustomFieldCanvas from '../../custom-fields/custom-field-canvas';
import { useEffect, useRef, useState } from 'react';
import NoDataComponent from '../../../../shared/no-data/no-data';
import DraggableSortingContainer from '../../../../shared/draggable-sorting-list/draggable-sorting-list';
import ReadonlyCustomFields from '../../custom-fields/shared/readonly-custom-fields';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

function ProgramAdditionalInfo({programID, programDetails}) {
    const { register, formState: {errors}, watch, setValue, control, trigger } = useFormContext();
    const fieldsWatcher = watch();
    const customFieldCanvasRef = useRef(null);

    const visibleRegistrant = (fieldsWatcher?.registrant ?? []).filter((f) => !f?.is_delete);
    const visibleParticipant = (fieldsWatcher?.participant ?? []).filter((f) => !f?.is_delete);

    const { fields: registrantFields } = useFieldArray({
        control,
        name: "registrant",
        // rules:{
        //      validate: (arr) =>
        //         (arr?.filter((f) => !f?.is_delete).length ?? 0) > 0 ||
        //         'Registrant fields are required',
        // }
    });

    const { fields: participantFields } = useFieldArray({
        control,
        name: "participant",
        rules:{
            validate: (arr) => {
                if (!fieldsWatcher?.enable_participant_info) return true;
                return (
                    (arr?.filter((f) => !f?.is_delete).length ?? 0) > 0 ||
                    'Participant fields are required'
                );
            },
        }
    });

    const attachRegistrantFields = (sectionType, fields) => {
        setValue(sectionType, fields ?? [], {
            shouldDirty: true,
            shouldTouch: true,
            shouldValidate: true,
        });
        trigger(sectionType);
    }

    const updateSortOrder = (items, field) => {
        const updatedOrder = items.map((it, index) => {
            it.sort_index = (index + 1);
            return it;
        });
        setValue(field, updatedOrder);
    }

    return (
        <>
            <div className='main-form-wrapper'>
                <h6 className="mb-3 text-black fw-bold">
                    <i className="fa-solid fa-edit text-primary me-2"></i>
                    Registration
                </h6>

                {/* Registration Window Section */}
                <div className='main-form-wrapper mb-4'>
                    <h6 className='mb-3 fw-bold'>Registration Window</h6>
                    <hr className='m-2' />

                    <div className='row mb-2'>
                        <div className='col-xxl-6 col-md-12'>
                            <Form.Group >
                                <Form.Label className='text-bold text-black'>Opens On</Form.Label>
                                <Form.Control
                                {...register("registration_open_date",{
                                    // validate: (value) => {
                                    //     if(value){
                                    //         if(programID && programDetails?.registration_open_date){
                                    //             if(programDetails?.registration_open_date !== value){
                                    //                 return ((new Date(value) >= new Date().setHours(0,0,0,0)) || "Registration open date must be today or later")    
                                    //             }

                                    //             return true;
                                    //         }else{
                                    //             return ((new Date(value) >= new Date().setHours(0,0,0,0)) || "Registration open date must be today or later")
                                    //         }
                                            
                                    //     }
                                    // }
                                })}
                                 type="date" />
                            </Form.Group>
                            {errors?.registration_open_date ? <FieldError message={errors?.registration_open_date?.message} /> : ''}
                        </div>
                        <div className='col-xxl-6 col-md-12'>
                            <Form.Group >
                                <Form.Label className='text-bold text-black'>Closes On</Form.Label>
                                <Form.Control
                                {...register("registration_close_date", {
                                    validate: (value, formValues) => {
                                        if(value){
                                            return (new Date(value) > new Date(formValues.registration_open_date) || "Registration end date must be greater then registration open date")
                                        }
                                    }
                                })}
                                 type="date" />
                            </Form.Group>
                            {errors?.registration_close_date ? <FieldError message={errors?.registration_close_date?.message} /> : ''}
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-xxl-12 col-md-12'>
                            <label className='d-flex align-items-center'>
                                <input className='me-1'
                            {...register("auto_close_registration")}
                                type="checkbox"
                            /> Automatically close registration
                            </label>
                        </div>
                    </div>
                </div>

                {/* Capacity & Rules Section */}
                <div className='main-form-wrapper mb-4'>
                    <h6 className='mb-3 fw-bold'>Capacity & Rules</h6>
                    <hr className='m-2' />
                    <p className='text-muted f-12-small'>Control how many participants can register and how registrations are grouped.</p>

                    <div className='row mb-2'>
                        <div className='col-xxl-6 col-md-12'>
                            <Form.Group className="mb-3">
                                <Form.Label className='text-bold text-black'>Maximum Capacity</Form.Label>
                                <Form.Control
                                {...register("max_capacity", {
                                    valueAsNumber: true,
                                    validate: (v) => {
                                                if(v){
                                                    const num = Number(v);
                                                return num > 0 || "Number must be greater than 0";
                                                }
                                            }
                                })}
                                 type="number" />
                                 
                            </Form.Group>
                            {errors?.max_capacity ? <FieldError message={errors?.max_capacity?.message} /> : ''}
                        </div>
                    </div>

                    <div className='row mb-3'>
                        <div className='col-xxl-12 col-md-12'>
                            <label className='d-flex align-items-center'>
                                <input className='me-1'
                            {...register("enable_participant_info")}
                                type="checkbox"
                            /> Enable Participant Information
                            </label>
                            <p className='text-muted f-12-small ms-4'>Show participant fields for programs where the registrant is signing up someone else (e.g., a parent registering a child).</p>
                        </div>
                    </div>

                    {
                        fieldsWatcher?.enable_participant_info ? 
                        <div className='row mb-3'>
                        <div className='col-xxl-12 col-md-12'>
                           <label className='d-flex align-items-center'>
                             <input className='me-1'
                            {...register("allow_multiple_participants")}
                                type="checkbox"
                            /> Allow multiple participants per registration
                           </label>
                            <p className='text-muted f-12-small ms-4'>Useful for classes like Sunday School or Quran programs where parents may register multiple children.</p>
                        </div>
                    </div> : ""
                    }
                </div>

                {/* Registrant Form Fields Section */}
                <div className='main-form-wrapper mb-4'>
                    <h6 className='mb-3 fw-bold'>Registrant Form Fields</h6>
                    <hr className='m-2' />
                    <p className='text-muted f-12-small'>Select what details to collect from the registrant. These fields identify the person completing the registration (e.g., a parent or attendee).</p>

                    <div className='row mb-4'>
                        <div className='col-xxl-12 col-md-12'>
                            <Form.Group className="mb-3">
                                <Form.Label className='text-bold text-black'>Section Header</Form.Label>
                                <Form.Control
                                {...register("main_section_label")}
                                 type="text" placeholder="Enter section header" />
                            </Form.Group>
                            {errors?.registrant?.root ? <FieldError message={errors?.registrant?.root?.message} /> : ''}
                        </div>
                    </div>

                    {/* Registrant Fields */}
                    <div className='mb-3'>
                        {
                        //     visibleRegistrant?.map((item, index) => {
                        //         return !item?.is_delete ?
                        //         <div key={`registrant_field_${index}`} className='d-flex justify-content-between align-items-center p-3 border rounded mb-2'>
                        //             <div>
                        //                 <Form.Label className='text-bold text-black mb-0'>{item?.field_label}</Form.Label>
                        //                 {item?.field_is_required ? <p className='text-muted f-12-small mb-0'>Required</p> : ''}
                        //             </div>
                        //             <button 
                        //             onClick={() => {
                        //     customFieldCanvasRef?.current?.handleShow('registrant', fieldsWatcher['registrant']);
                        // }}
                        //             type='button' className='btn btn-sm btn-outline-primary'>Edit</button>
                        //         </div> : ''
                        //     })

                            <DndProvider backend={HTML5Backend}>
                            <div className='col-12 card'>
                                <div className='card-body p-3'>
                                        <div className='tile w-100'>
                                            <ReadonlyCustomFields disableEdit={true} item={{ field_type: 'text', field_label: 'First Name', field_is_required: true }} />
                                        </div>
                                        <div className='tile w-100'>
                                            <ReadonlyCustomFields disableEdit={true} item={{ field_type: 'text', field_label: 'Last Name', field_is_required: true }} />

                                        </div>
                                        <div className='tile w-100'>
                                            <ReadonlyCustomFields disableEdit={true} item={{ field_type: 'text', field_label: 'Email', field_is_required: true }} />
                                        </div>
                                    
                                    {/* readonly fields */}
                                    {visibleRegistrant?.length > 0 ? 
                                        <DraggableSortingContainer
                                            items={visibleRegistrant}
                                            onChange={(items) => updateSortOrder(items, 'registrant')}
                                            renderItem={(item, isDragging) => {
                                                return <ReadonlyCustomFields 
                                                item={item} customFieldCanvasRef={{
                                                    current:{
                                                        handleShow: () => {
                                                            customFieldCanvasRef?.current?.handleShow('registrant', fieldsWatcher['registrant'])
                                                        }
                                                    }
                                                }} />
                                            }}
                                        />
                                    
                                     : ''}
                                    <div className='text-center'>
                                        <button type='button' className='btn btn-outline-primary mb-0'
                                            onClick={() => customFieldCanvasRef?.current?.handleShow('registrant', fieldsWatcher['registrant'])}>
                                            <i className="fa-solid fa-paperclip me-2"></i>
                                            Add Custom Fields</button>
                                    </div>
                                </div>
                            </div>
                        </DndProvider>
                        }
                        {/* {visibleRegistrant.length === 0 ? <>
                            <NoDataComponent message={'Registrant fields not attached!'} />
                        </> : ''} */}
                    </div>

                    {/* <div className='text-center'>
                        <button 
                        onClick={() => {
                            customFieldCanvasRef?.current?.handleShow('registrant', fieldsWatcher['registrant']);
                        }}
                         type='button' className='btn btn-outline-primary'>Add Custom Fields</button>
                    </div> */}
                </div>
                {/* Participant Form Fields Section */}
                {
                    fieldsWatcher?.enable_participant_info ? 
                    <div className='main-form-wrapper'>
                    <h6 className='mb-3 fw-bold'>Participant Form Fields</h6>
                    <hr className='m-2' />
                    <p className='text-muted f-12-small'>Choose what details to collect for each participant. These fields apply to every person being registered, such as a student in a class or a child in a youth program.</p>

                    <div className='row mb-4'>
                        <div className='col-xxl-12 col-md-12'>
                            <Form.Group className="mb-3">
                                <Form.Label className='text-bold text-black'>Section Header</Form.Label>
                                <Form.Control
                                {...register("sub_section_label")}
                                 type="text" placeholder="Enter section header" />
                            </Form.Group>
                            {errors?.participant?.root ? <FieldError message={errors?.participant?.root?.message} /> : ''}
                        </div>
                    </div>

                    {/* Participant Fields */}
                    <div className='mb-3'>
                        {
                        //     visibleParticipant?.map((item, index) => {
                        //         return !item?.is_delete ? 
                        //         <div key={`participant_field_${index}`} className='d-flex justify-content-between align-items-center p-3 border rounded mb-2'>
                        //             <div>
                        //                 <Form.Label className='text-bold text-black mb-0'>{item?.field_label}</Form.Label>
                        //                 {item?.field_is_required ? <p className='text-muted f-12-small mb-0'>Required</p> : ''}
                        //             </div>
                        //             <button
                        //             onClick={() => {
                        //     customFieldCanvasRef?.current?.handleShow('participant', fieldsWatcher['participant']);
                        // }}
                        //              type='button' className='btn btn-sm btn-outline-primary'>Edit</button>
                        //         </div> : ''
                        //     })
                        <DndProvider backend={HTML5Backend}>
                            <div className='col-12 card'>
                                <div className='card-body p-3'>
                                    {/* readonly fields */}
                                    {visibleParticipant?.length > 0 ? 
                                        <DraggableSortingContainer
                                            items={visibleParticipant}
                                            onChange={(items) => updateSortOrder(items, 'participant')}
                                            renderItem={(item, isDragging) => {
                                                return <ReadonlyCustomFields 
                                                item={item} customFieldCanvasRef={{
                                                    current:{
                                                        handleShow: () => {
                                                           customFieldCanvasRef?.current?.handleShow('participant', fieldsWatcher['participant']) 
                                                        }
                                                    }
                                                }} />
                                            }}
                                        />
                                    
                                     : ''}
                                    <div className='text-center'>
                                        <button type='button' className='btn btn-outline-primary mb-0'
                                            onClick={() => customFieldCanvasRef?.current?.handleShow('participant', fieldsWatcher['participant'])}>
                                            <i className="fa-solid fa-paperclip me-2"></i>
                                            Add Custom Fields</button>
                                    </div>
                                </div>
                            </div>
                        </DndProvider>
                        }
                        {visibleParticipant.length === 0 ? <>
                            <NoDataComponent message={'Participant fields not attached!'} />
                        </> : ''}
                        
                    </div>

                    {/* <div className='text-center'>
                        <button type='button'
                         onClick={() => {
                            customFieldCanvasRef?.current?.handleShow('participant', fieldsWatcher['participant']);
                        }}
                         className='btn btn-outline-primary'>Add Custom Fields</button>
                    </div> */}
                </div> : ""
                }
                
                
            </div>

            {/* custom canvas start */}
            <CustomFieldCanvas
            onCloseRefresh={attachRegistrantFields}
                ref={customFieldCanvasRef} entityInfo={{
                    entity_id: programID || null,
                    entity_type: 'programs'
                }} />
            {/* custom canvas end */}
        </>
    );
}

export default ProgramAdditionalInfo;